// extracted by mini-css-extract-plugin
export default {"button":"_2lkJ6pY_H_8tR0I7T7jcgt","tooltip":"_1e_-q8UgOKVryiWB052quS"};